var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGettingStartedFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16ZM8 6.8688L5.7376 4.6056L4.6056 5.7376L6.8688 8L4.6056 10.2624L5.7376 11.3944L8 9.1312L10.2624 11.3944L11.3944 10.2624L9.1312 8L11.3944 5.7376L10.2624 4.6056L8 6.8688Z",
    fill: "#AD3737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettingStartedFailure);
export default __webpack_public_path__ + "static/media/getting_started_failure.74f9e9f4d441431aa0b707c6c46080cd.svg";
export { ForwardRef as ReactComponent };